import { render } from "./ConfigData.vue?vue&type=template&id=8cb1d34a"
import script from "./ConfigData.vue?vue&type=script&lang=js"
export * from "./ConfigData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__